import axios from "../axios";
import { buildChecklistTypeSavePayload } from "../../components/dashboard/quality/checklists/checklistTypeSavePayload";

export async function fetchChecklistTypes(controller) {
  return axios({
    method: "get",
    url: "/quality/checklists/types",
    params: controller,
  });
}

export async function fetchChecklistType(id, params = {}) {
  return axios({
    method: "get",
    url: `/quality/checklists/types/${id}`,
    params,
  });
}

export async function createChecklistType(payload) {
  const type = buildChecklistTypeSavePayload(payload, {
    sourceItems: payload?.sourceItems || payload?.items,
  });
  return axios({
    method: "post",
    url: "/quality/checklists/types",
    data: { type },
  });
}

export async function updateChecklistType(payload) {
  const type = buildChecklistTypeSavePayload(payload, {
    sourceItems: payload?.sourceItems || payload?.items,
  });
  return axios({
    method: "put",
    url: "/quality/checklists/types/" + type.id,
    data: { type },
  });
}

export async function deleteChecklistType(payload) {
  return axios({
    method: "delete",
    url: "/quality/checklists/types/" + payload,
  });
}

export async function fetchChecklistTypePdf(id) {
  return axios({
    method: "get",
    url: `/quality/checklists/types/${id}/pdf`,
  })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response?.data || error));
}

export async function registerChecklistTypeHse(id, payload = {}) {
  return axios({
    method: "post",
    url: `/quality/checklists/types/${id}/register_hse_document`,
    data: payload,
  })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response?.data || error));
}
